export default "__VITE_ASSET__6c5b61f9__"